"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    boxSizing: prop_types_1.default.string,
    clear: prop_types_1.default.string,
    clearfix: prop_types_1.default.bool,
    display: prop_types_1.default.string,
    float: prop_types_1.default.string,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])
};
exports.propAliases = {};
exports.propValidators = {};
const display = {
    className: 'dspl',
    cssName: 'display',
    jsName: 'display',
    safeValue: true,
    isPrefixed: true
};
const float = {
    className: 'flt',
    cssName: 'float',
    jsName: 'float',
    safeValue: true
};
const clear = {
    className: 'clr',
    cssName: 'clear',
    jsName: 'clear',
    safeValue: true
};
const zIndex = {
    className: 'z-idx',
    cssName: 'z-index',
    jsName: 'zIndex',
    safeValue: true,
    defaultUnit: ''
};
const boxSizing = {
    className: 'box-szg',
    cssName: 'box-sizing',
    jsName: 'boxSizing',
    safeValue: true
};
exports.propEnhancers = {
    boxSizing: (value) => get_css_1.default(boxSizing, value),
    clear: (value) => get_css_1.default(clear, value),
    clearfix: () => ({
        className: 'ub-clearfix',
        styles: `
.ub-clearfix:before, .ub-clearfix:after {
  display: table;
  clear: both;
  content: "";
}`
    }),
    display: (value) => get_css_1.default(display, value),
    float: (value) => get_css_1.default(float, value),
    zIndex: (value) => get_css_1.default(zIndex, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGF5b3V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2VuaGFuY2Vycy9sYXlvdXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSw0REFBa0M7QUFDbEMseURBQStCO0FBR2xCLFFBQUEsU0FBUyxHQUFxQjtJQUN6QyxTQUFTLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQzNCLEtBQUssRUFBRSxvQkFBUyxDQUFDLE1BQU07SUFDdkIsUUFBUSxFQUFFLG9CQUFTLENBQUMsSUFBSTtJQUN4QixPQUFPLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQ3pCLEtBQUssRUFBRSxvQkFBUyxDQUFDLE1BQU07SUFDdkIsTUFBTSxFQUFFLG9CQUFTLENBQUMsU0FBUyxDQUFDLENBQUMsb0JBQVMsQ0FBQyxNQUFNLEVBQUUsb0JBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBQztDQUNsRSxDQUFBO0FBRVksUUFBQSxXQUFXLEdBQWdCLEVBQUUsQ0FBQTtBQUM3QixRQUFBLGNBQWMsR0FBbUIsRUFBRSxDQUFBO0FBRWhELE1BQU0sT0FBTyxHQUFHO0lBQ2QsU0FBUyxFQUFFLE1BQU07SUFDakIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsTUFBTSxFQUFFLFNBQVM7SUFDakIsU0FBUyxFQUFFLElBQUk7SUFDZixVQUFVLEVBQUUsSUFBSTtDQUNqQixDQUFBO0FBQ0QsTUFBTSxLQUFLLEdBQUc7SUFDWixTQUFTLEVBQUUsS0FBSztJQUNoQixPQUFPLEVBQUUsT0FBTztJQUNoQixNQUFNLEVBQUUsT0FBTztJQUNmLFNBQVMsRUFBRSxJQUFJO0NBQ2hCLENBQUE7QUFDRCxNQUFNLEtBQUssR0FBRztJQUNaLFNBQVMsRUFBRSxLQUFLO0lBQ2hCLE9BQU8sRUFBRSxPQUFPO0lBQ2hCLE1BQU0sRUFBRSxPQUFPO0lBQ2YsU0FBUyxFQUFFLElBQUk7Q0FDaEIsQ0FBQTtBQUNELE1BQU0sTUFBTSxHQUFHO0lBQ2IsU0FBUyxFQUFFLE9BQU87SUFDbEIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsU0FBUyxFQUFFLElBQUk7SUFDZixXQUFXLEVBQUUsRUFBRTtDQUNoQixDQUFBO0FBQ0QsTUFBTSxTQUFTLEdBQUc7SUFDaEIsU0FBUyxFQUFFLFNBQVM7SUFDcEIsT0FBTyxFQUFFLFlBQVk7SUFDckIsTUFBTSxFQUFFLFdBQVc7SUFDbkIsU0FBUyxFQUFFLElBQUk7Q0FDaEIsQ0FBQTtBQUVZLFFBQUEsYUFBYSxHQUFrQjtJQUMxQyxTQUFTLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLFNBQVMsRUFBRSxLQUFLLENBQUM7SUFDckUsS0FBSyxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDO0lBQzdELFFBQVEsRUFBRSxHQUFHLEVBQUUsQ0FBQyxDQUFDO1FBQ2YsU0FBUyxFQUFFLGFBQWE7UUFDeEIsTUFBTSxFQUFFOzs7OztFQUtWO0tBQ0MsQ0FBQztJQUNGLE9BQU8sRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsT0FBTyxFQUFFLEtBQUssQ0FBQztJQUNqRSxLQUFLLEVBQUUsQ0FBQyxLQUE0QixFQUFFLEVBQUUsQ0FBQyxpQkFBTSxDQUFDLEtBQUssRUFBRSxLQUFLLENBQUM7SUFDN0QsTUFBTSxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDO0NBQ2hFLENBQUEifQ==